import { UnsavedChangesDialog } from '@/components';
import { useUnsavedChangesDialogStore } from '@core/store';
import React, { useEffect, useRef } from 'react';
import { UnsavedChangesDialogRef } from '@/components/dialog/UnsavedChangesDialog.tsx';

const AppUnsavedChangesDialog: React.FC = () => {
    const { unsavedChangesRequest, closeUnsavedChangesDialog } = useUnsavedChangesDialogStore();
    const dialogRef = useRef<UnsavedChangesDialogRef>(null);
    const wasOpen = useRef(false);

    useEffect(() => {
        if (unsavedChangesRequest && !wasOpen.current) {
            dialogRef.current?.openDialog();
        }
        wasOpen.current = !!unsavedChangesRequest;
    }, [unsavedChangesRequest]);

    return (
        <UnsavedChangesDialog
            dialogRef={dialogRef}
            heading={unsavedChangesRequest?.heading}
            message={unsavedChangesRequest?.message}
            onDiscard={() => {
                unsavedChangesRequest?.onDiscard();
                closeUnsavedChangesDialog();
            }}
            onStay={() => {
                unsavedChangesRequest?.onStay();
                closeUnsavedChangesDialog();
            }}
            onSaveAndLeave={
                unsavedChangesRequest?.onSaveAndLeave &&
                (async () => {
                    const saved = await unsavedChangesRequest.onSaveAndLeave!();
                    if (saved) {
                        closeUnsavedChangesDialog();
                        dialogRef.current?.closeDialog();
                    }
                })
            }
        />
    );
};

AppUnsavedChangesDialog.displayName = 'AppUnsavedChangesDialog';

export default AppUnsavedChangesDialog;
